export default {
  TITLE: `Requêtes de congé`,
  SUMMARY: ``,
  DATES: `Dates`,
  VACATIONTYPE: `Type`,
  TIME_OFFS_THIS_YEAR: `{{name}} a demandé {{count}} congé en {{year}}.`,
  TIME_OFFS_THIS_YEAR_other: `{{name}} a demandé {{count}} congés en {{year}}.`
}
